var Handlebars = require("handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<div>\n  <div id=\"notification-banner\" class=\"promo-tout notification-banner\" data-embed-id=\""
    + alias2(alias1((depth0 != null ? depth0.banner_id : depth0), depth0))
    + "\">\n    <div class=\"render-container\">\n        <div class=\"link-container\">\n            <a href=\""
    + alias2(alias1((depth0 != null ? depth0.banner_redirect_url : depth0), depth0))
    + "\" target=\"_blank\">\n                <div class=\"banner-img-container\">\n                    <img src=\""
    + alias2(alias1((depth0 != null ? depth0.banner_image_url : depth0), depth0))
    + "\"></div>\n                    <div class=\"text-container promo-tout-desktop-only\">\n                        <div class=\"text-inner-container banner-desktop-title\">"
    + alias2(alias1((depth0 != null ? depth0.banner_desktop_title : depth0), depth0))
    + "</div>\n                    </div>\n                    <div class=\"text-container promo-tout-mobile-only\">\n                        <div class=\"text-inner-container banner-mobile-title\">"
    + alias2(alias1((depth0 != null ? depth0.banner_mobile_title : depth0), depth0))
    + "</div>\n                    </div>\n            </a>\n            </div>\n            <div class=\"close-banner-container\">\n                <img class=\"close-banner\" src=\""
    + alias2(__default(require("unicorn/shared/helpers/publicPath.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"/img/icons/close-btn.svg",{"name":"publicPath","hash":{},"data":data}))
    + "\">\n            </div>\n        </div>\n  </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./~/unicorn/shared/components/navigation/partials/notification-banner.hbs
// module id = 122
// module chunks = 11